import apiService from './ApiService';

class AulaArchivosService {
  async list(aulaId) {
    return apiService.get(`/aulas/${aulaId}/archivos`);
  }

  async upload(aulaId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiService.request(`/aulas/${aulaId}/archivos`, {
      method: 'POST',
      body: formData,
    });
  }

  async delete(aulaId, archivoId) {
    return apiService.delete(`/aulas/${aulaId}/archivos/${archivoId}`);
  }

  async downloadZip(aulaId) {
    const url = `${apiService.baseURL}/aulas/${aulaId}/archivos/zip`;
    const headers = apiService.getAuthHeaders();
    const resp = await fetch(url, { headers });
    if (!resp.ok) throw new Error('No pudimos descargar el ZIP.');
    const blob = await resp.blob();
    return blob;
  }

  async downloadFile(aulaId, archivoId) {
    const url = `${apiService.baseURL}/aulas/${aulaId}/archivos/${archivoId}`;
    const headers = apiService.getAuthHeaders();
    const resp = await fetch(url, { headers });
    if (!resp.ok) throw new Error('No pudimos descargar el archivo.');
    const blob = await resp.blob();
    return blob;
  }
}

const aulaArchivosService = new AulaArchivosService();
export default aulaArchivosService;
